import type { RootState } from '..';

export const selectEstablishments = (state: RootState) =>
  state.establishment.establishments;
